import NavbarNotAuth from './components/navbarNotAuth'
import DivBottom from './components/divBottom'
import CercaFoodTruck from './components/cercaFoodTruck'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

function FoodTruckPerGenere() {
    const navigate = useNavigate()
    const location = useLocation()
    const foodTrucks = location.state.genere; const mode = location.state.mode;
    const tipoCucina = location.state.tipoCucina; const luogo = location.state.luogo

    const [dati, setDati] = useState({})
    const [tipoCuc, setTipoCucina] = useState([])
    const [img, setImg] = useState({ img: [], video: null })

    const divDettagli = useRef()
    const opacityDivDettagli = useRef()
    const vbn = useRef([])
    const details = {
        display: 'grid', gridTemplateColumns: '0.25fr 1fr', gap: '5px'
    }

    function dettagli(e) {
        let vb
        setDati(e)
        setImg({ img: e.img.split(','), video: e.video })
        setTipoCucina(e.genere.split(','))
        if (e.img) { vbn.current = e.img.split(',') }
        divDettagli.current.style.top = '0'
    }

    return (<>
        {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <p style={{ margin: '5rem 0 0 2rem' }}>\<b>foodTruckPerGenere</b></p>
        <CercaFoodTruck />
        <div className='container' style={{ marginBottom: '6rem' }}>
            <div>
                {mode === 'genere' ?
                    <h4 style={{ marginTop: '2rem', textAlign: 'center' }}>TROVATI {foodTrucks.length} FOODTRUCK COME <i>{tipoCucina}</i></h4>
                    : mode === 'luogo' ?
                        <h4 style={{ marginTop: '2rem', textAlign: 'center' }}>TROVATI {foodTrucks.length} FOODTRUCK IN {luogo}</h4>
                        : null}
                {foodTrucks.map(foodTruck => {
                    let cv; let arrTipoCucina = []
                    if (foodTruck.img) {
                        cv = foodTruck.img.split(',')
                    }
                    if (foodTruck.genere) arrTipoCucina = foodTruck.genere.split(',')
                    return (
                        <div key={foodTruck.id} style={{
                            border: '1px solid grey', borderRadius: '10px', padding: '1rem', marginTop: '1rem'
                        }}>
                            {foodTruck.img ?
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${cv[0]}`} style={{ borderRadius: '5px', maxWidth: '100px', maxHeight: '100px' }} />
                                :
                                <img src={require('./image/icons8-impostazioni-amministratore-maschio-32.png')} />
                            }
                            <span style={{ marginLeft: '1rem' }}><b>{foodTruck.nome}</b></span>

                            {arrTipoCucina.length !== 0 &&
                                <div style={{ display: 'grid', gridTemplateColumns: '35px 1fr', gap: '5px', marginTop: '1em' }}>
                                    <div>
                                        <img src={require('./image/icons8-cucina-48.png')} width='25rem' />
                                    </div>
                                    <div>
                                        {arrTipoCucina.map((elem, index) => (
                                            <span key={index}> {elem}
                                                {index < arrTipoCucina.length - 1 && <span>,</span>}
                                            </span>
                                        ))
                                        }
                                    </div>
                                </div>
                            }


                            {foodTruck.telefono &&
                                <div className='mt-2'><img src={require('./image/icons8-telefono-cellulare-48.png')} width='25rem' style={{ marginRight: '1rem' }} />
                                    {foodTruck.telefono}
                                </div>
                            }

                            <div className='mt-1'>
                                <img src={require('./image/icons8-nuovo-messaggio-48.png')} width="25rem" />
                                <span style={{ marginLeft: '1rem' }}>{foodTruck.emailUser}</span>
                            </div>

                            {foodTruck.url &&
                                <b><a href={foodTruck.url} target='_blank'> Sito web </a></b>
                            }

                            <div style={{ marginTop: '1rem', marginBottom: '4rem' }}>
                                <button className='btn btn-primary float-start' onClick={() => { dettagli(foodTruck) }}
                                    style={{ fontSize: 'small' }}>
                                    Dettagli
                                </button>
                            </div>
                        </div>
                    )
                })
                }
            </div>

            <div style={{ margin: '3rem 0 12rem 0' }}>
                <button type='button' className='btn btn-secondary float-start' onClick={() => {
                    navigate('/foodTruck', { replace: true })
                }}>Indietro
                </button>
            </div>

            {/* -------------------------------------------------- BANNER DEI DETTAGLI -------------------------------------------------------- */}
            <div className='visualDettagli' ref={divDettagli}>
                {dati.idUser &&
                    <div>
                        <div style={{
                            float: 'right', cursor: 'pointer', borderRadius: '50%', backgroundColor: 'lightgrey', textAlign: 'center',
                            width: '45px', height: '45px', fontSize: '28px'
                        }} onClick={() => { divDettagli.current.style.top = '120%' }}>
                            X
                        </div><br />

                        <div style={{ marginBottom: '1rem' }}>
                            {dati.img ?
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${vbn.current[0]}`} style={{ maxWidth: "220px", maxHeight: '180px' }} />
                                : <img src={require('./image/icons8-impostazioni-amministratore-maschio-32.png')} />
                            }
                        </div>

                        <div style={details} className='mt-5'>
                            <div>Nome:</div><div><b>{dati.nome}</b></div>
                            <div>Città:</div><div><b>{dati.città}</b></div>
                            <div>Regione:</div><div><b>{dati.regione}</b></div>
                        </div>

                        {dati.genere &&
                            <div style={details} className='mt-3'>
                                <div>Genere: </div>
                                <div>
                                    {tipoCuc.map((elem, index) => (
                                        <span key={index}>{elem}
                                            {index < tipoCuc.length && <span>, </span>}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        }
                        {dati.soggetto &&
                            <div style={details} className='mt-1'>
                                <div>Specialità: </div>
                                <div>{dati.soggetto}</div>
                            </div>
                        }

                        <hr />
                        <div style={details}>
                            <div>Email:</div><div><b>{dati.emailUser}</b></div>
                        </div>
                        {dati.telefono !== '' &&
                            <div style={details}>
                                <div>Telefono:</div><div><b>{dati.telefono}</b></div>
                            </div>}

                        <p className='text-center mt-3'>⇓ DESCRIZIONE ⇓</p>
                        <textarea className='textAreaEventi mt-1' rows='7' style={{ borderTop: '1px solid grey' }} defaultValue={dati.descrizione} />

                        {img.img[1] &&
                            <div style={{ margin: '1em auto' }} className='row'>
                                {img.img.map((elem, index) => {
                                    if (index !== 0) return (
                                        <div key={index} className="mt-3" style={{
                                            width: '26rem', height: '100%',
                                            padding: '0px',
                                            margin: '0 auto'
                                        }}>
                                            {index !== 0 &&
                                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`}
                                                    style={{ maxWidth: '100%', maxHeight: '180px', border: '3px solid gainsboro' }} />
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        {img.video &&
                            <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px' }}>
                                <h5 className='text-center'>VIDEO DEL FOODTRUCK</h5>
                                <div className='text-center mt-3'>
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${img.video}`} id={'videoPreview'}
                                        style={{ width: '100%', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }

                        <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                            <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                            {dati.url &&
                                <div className='btn btn-warning'>
                                    <a href={dati.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                                </div>
                            }
                            {dati.fb &&
                                <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                    <a href={dati.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank'><b>f</b></a>
                                </span>
                            }
                            {dati.youtube &&
                                <span style={{ backgroundColor: 'red', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                    <a href={dati.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank'><b>▷</b></a>
                                </span>
                            }
                            {!dati.url && !dati.fb && !dati.youtube &&
                                <div>Nessun link presente </div>
                            }
                        </div>

                        <div className='mt-5' style={{ marginBottom: '2rem' }}>
                            <button className='btn btn-secondary'
                                onClick={() => {
                                    divDettagli.current.style.width = '0'
                                    divDettagli.current.style.left = '-15%'
                                    opacityDivDettagli.current.style.opacity = '0'
                                }}>Indietro
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
        <DivBottom />
    </>)
}
export default FoodTruckPerGenere